'use client'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { useQuery } from '@tanstack/react-query'
import services from '../services'
import { API_END_POINTS } from '@/shared/api/end-points'
import { SelectionDictionaryParams } from '../services'
import { dictionaryMappers } from '../../lib'

const useQueryHook = (params: SelectionDictionaryParams) => {
  const queryKey = [queryKeys((a, m, p) => params(API_END_POINTS.dictionary) + m.get)]
  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.get(params)),
  })

  return {
    ...query,
    data: dictionaryMappers.mapDictionaries(query.data || []),
  }
}

const hook = {
  useQueryHook,
}

export default hook
